import { Component, Input } from '@angular/core';
import { PRIMENG_MODULES } from '../../primeng-imports';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone:true,
  imports:[...PRIMENG_MODULES]
})
export class SpinnerComponent {
  @Input() isLoading: boolean = false;

  constructor() {}
}
